import React, { useEffect, useState } from 'react';
import SignUpHeader from './SignUpHeader';
import lovely from '../../../assets/img/lovely.svg';
import tickcircle from '../../../assets/img/tick-circle.svg';
import APIServices from 'services/APIServices';
import { selectLoader } from 'utils/Helpers';
import { Link } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';

const SubPlan = ({ isHome = false }) => {
  const { user } = useAuth();
  const [userId, setUserId] = useState('');
  const [plans, setPlans] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isActivating, setActivating] = useState(false);

  useEffect(() => {
    if (user) {
      setUserId(user._id);
      fetchPlans();
    }
  }, [user]);

  const fetchPlans = async () => {
    try {
      const planData = await APIServices.get('/subscription/plans');
      setPlans(planData.plans || []);
    } catch (error) {
      console.error('Error fetching subscription plans:', error);
    } finally {
      setLoading(false);
    }
  };

  const activateSubscription = async (itemPriceId) => {
    if (!itemPriceId || isActivating) return;

    try {
      setActivating(true);
      const payload = { userId, itemPriceId };
      const response = await APIServices.post('/subscription/create-checkout-hosted-page', payload);
      const checkoutUrl = response?.hostedPage?.url;

      if (!checkoutUrl) {
        throw new Error('Stripe checkout URL not found.');
      }

      window.location.href = checkoutUrl;
    } catch (error) {
      setActivating(false);
      console.error('Error starting Stripe checkout:', error);
    }
  };

  return (
    <div className="wrapper welcome-page">
      <div className="main-content">
        {!isHome && <SignUpHeader userName={user?.fullName} />}
        <div className="feature-sec plan-sec plan-list-sec pb-5">
          <div className="container">
            <div className="row justify-content-center">
              {isLoading ? (
                <div className="nodata-loader">{selectLoader(75)}</div>
              ) : (
                <div className="col-lg-12 col-md-12 col-sm-12">
                  {plans?.map((plan) => {
                    const priceObj = plan.prices?.[0];
                    const monthlyPrice = (priceObj?.price || 0) / 100;

                    return (
                      <div className="plan-card-box plan-card-box-width" key={plan.id}>
                        <div className="plan-content-head">
                          <img src={lovely} alt="lovely" className="lovely" />
                          <h2>{plan.externalName || plan.name}</h2>
                        </div>

                        <span>
                          ${monthlyPrice.toFixed(2)} <sub>/month</sub>
                        </span>

                        <ul
                          className="plan-list"
                          dangerouslySetInnerHTML={{
                            __html: (plan.description || '')
                              .replace(/\\n/g, '') // 🔥 remove literal "\n"
                              .replace(/(\r\n|\n|\r)/g, '') // (optional) real newlines
                              .replace(/>\s+</g, '><')
                              .replace(
                                /<li>/g,
                                `<li class="dark-text"><img src="${tickcircle}" alt="tick" class="tickcircle"/><p>`
                              )
                              .replace(/<\/li>/g, '</p></li>')
                          }}
                        />

                        <button
                          className="btn-black"
                          type="button"
                          onClick={() => activateSubscription(priceObj?.id)}
                          disabled={isActivating}>
                          {isActivating ? selectLoader(30) : 'Get Started'}
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {!isHome && (
              <Link to="/projects" className="choose-later">
                I’ll Choose Later
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubPlan;
